import * as Actions from "./constants";
const initialState = {
  coupons: [],
  singleCoupon:[],
  couponLoaded:false,
  createBundleSuccess:false,
  deleteBundleSuccess:false,
  updateBundleSuccess:false,
  emailSuccess:false,
  updateCouponSuccess:false
};

export default function couponReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GENERATE_COUPON:
      return {
        ...state,
        createBundleSuccess:false
      };
    case Actions.GENERATE_COUPON_SUCCESS:
      return {
        ...state,
        data: action.payload,
        createBundleSuccess:true
      };
    case Actions.GENERATE_COUPON_ERROR:
      return {
        ...state,
        error: action.error,
        createBundleSuccess:false
      };
    case Actions.GET_COUPON_BUNDLE:
      return {
        ...state,
      };
    case Actions.GET_COUPON_BUNDLE_SUCCESS:
      return {
        ...state,
        bundles: action.payload,
      };
    case Actions.GET_COUPON_BUNDLE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.GET_COUPON_BY_BUNDLE:
      return {
        coupons:[],
        ...state,
      };
    case Actions.GET_COUPON_BY_BUNDLE_SUCCESS:
      return {
        ...state,
        coupons: action.payload,
      };
    case Actions.GET_COUPON_BY_BUNDLE_ERROR:
      return {
        ...state,
        coupons:[],
        error: action.error,
      };
    case Actions.DELETE_BUNDLE:
      return {
        coupons:[],
        ...state,
        deleteBundleSuccess:false
      };
    case Actions.DELETE_BUNDLE_SUCCESS:
      return {
        ...state,
        coupons: action.payload,
        deleteBundleSuccess:true
      };
    case Actions.DELETE_BUNDLE_ERROR:
      return {
        ...state,
        coupons:[],
        error: action.error,
        deleteBundleSuccess:false
      };
    case Actions.DELETE_COUPON:
      return {
        singleCoupon:[],
        ...state,
        deleteCouponSuccess:false
      };
    case Actions.DELETE_COUPON_SUCCESS:
      return {
        ...state,
        singleCoupon: action.payload,
        deleteCouponSuccess:true
      };
    case Actions.DELETE_COUPON_ERROR:
      return {
        ...state,
        singleCoupon:[],
        error: action.error,
        deleteCouponSuccess:false
      };
    case Actions.EDIT_BUNDLE:
      return {
        ...state,
      };
    case Actions.EDIT_BUNDLE_SUCCESS:
      return {
        ...state,
        couponData:action.payload
      };
    case Actions.EDIT_BUNDLE_ERROR:
      return {
        ...state,
      };
    case Actions.UPDATE_BUNDLE:
      return {
        ...state,
        coupons:[],
        updateBundleSuccess:false,
      };
    case Actions.EDIT_COUPON:
      return {
        ...state,
      };
    case Actions.EDIT_COUPON_SUCCESS:
      return {
        ...state,
        singlCouponData:action.payload
      };
    case Actions.EDIT_COUPON_ERROR:
      return {
        ...state,
      };
    case Actions.UPDATE_BUNDLE:
      return {
        ...state,
        coupons:[],
        updateBundleSuccess:false,
      };
    case Actions.UPDATE_BUNDLE_SUCCESS:
      return {
        ...state,
        coupons: action.payload,
        updateBundleSuccess:true,
      };
    case Actions.UPDATE_BUNDLE_ERROR:
      return {
        ...state,
        coupons:[],
        error: action.error,
        updateBundleSuccess:false,
      };
    case Actions.UPDATE_COUPON:
      return {
        ...state,
        singleCoupon:[],
        updateCouponSuccess:false,
      };
    case Actions.UPDATE_COUPON_SUCCESS:
      return {
        ...state,
        singleCoupon: action.payload,
        updateCouponSuccess:true,
      };
    case Actions.UPDATE_COUPON_ERROR:
      return {
        ...state,
        singleCoupon:[],
        error: action.error,
        updateCouponSuccess:false,
      };
    case Actions.COUPON_RESEND_EMAIL:
      return {
        ...state,
        emailSuccess:false,
      };
    case Actions.COUPON_RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailSuccess:true
      };
    case Actions.COUPON_RESEND_EMAIL_ERROR:
      return {
        ...state,
        emailSuccess:false
      };
    default:
      return state;
  }
}
